<div class="js-menu">
  <div class="smag-button-container"
       ></div>
  <div class="jarvis-menu-image">
    <div [ngStyle]="{'background-image' : 'url(' + ImageUrl + ')'}">
      <span class="jarvis-menu-image-customlabel" *ngIf="CoopName">by {{CoopName}}</span>
    </div>
  </div>
  <div class="jarvis-menu-container">
    <div [ngClass]="{showfilter: showPopupFilter}" class="menu-filters">
      <div class="mobile-filter">
        <span (click)="togglePopupFilter()" class="filter-icon k-icon k-font-icon k-i-filter"></span>
        <span (click)="togglePopupFilter()">Filtres</span>
      </div>
      <div class="list-menu">
        <div *ngFor="let menu of FilterMenus()" class="jarvis-ui-menu">

          <div class="multiselectable" *ngIf="menu.Checkable == 1" >
            <div class="menu-title" (click)=" IsMobile && toggleMobileMenu(menu.Code)">
               <i *ngIf="IsMobile" class="chevron-menu-expending" [ngClass]="collapsedMenus[menu.Code] ? 'fa fa-chevron-right' : 'fa fa-chevron-down'"></i>
              {{menu.Title}} 
              
            </div>
            <div (mouseleave)="onMouseLeaveFilter($event, menu.Code, 'mouseleave')" class="menu-items ddl-filter" *ngIf="!IsMobile || !collapsedMenus[menu.Code]">


              <!-- Barre de recherche -->
              <div class="search-container" *ngIf="allItems(menu).length > 4 && (menu.Code === 'cultivation' || (menu.Code === MenuFarmCode && searchInputVisible))">
                <kendo-textbox
                  [(ngModel)]="searchTerms[menu.Code]"
                  (valueChange)="onSearchChange(menu.Code, $event)"
                  [clearButton]="true"
                  placeholder="Rechercher..."
                  class="search-textbox">

                  <!-- Icône de recherche -->
                  <ng-template kendoTextBoxPrefixTemplate>
                    <span class="k-icon k-i-search"></span>
                  </ng-template>

                </kendo-textbox>
              </div>

              <div *ngIf="Selected(menu.Code) > 1" class="count_select">
                {{Selected(menu.Code)}} éléments sélectionnés
              </div>
              <div *ngIf="Selected(menu.Code) == 1" class="menu-item checked_true firstselected">
                {{SelectedText(menu.Code)}}
              </div>

              <!-- Liste des éléments sélectionnés (si plusieurs sélections) -->
              <div *ngIf="Selected(menu.Code) > 0" class="selected-items-section" >
                <div class="selected-items-header">Éléments sélectionnés : <img *ngIf="menu.MultiMaxAlertSelectable && menu.MultiMaxAlertSelectable<=Selected(menu.Code) && menu.MultiMaxSelectable<CountRecords(menu.Code)"  class="ic-max-selection_over" title="{{menu.MultiMaxSelectableTltp}}" /></div>
 
                <div *ngFor="let group of menu.GroupItems">
                  <div *ngIf="group.Title != 'Default' && menu.GroupItems.length > 1 && hasSelectedItemsInGroup(group)"
                       class="group-title selected-group">
                    {{group.Title}}   <span *ngIf="menu.Code === MenuFarmCode" class="ico-delete-group-selection" (click)="ClearFarmSelection()" title="{{IconDeleteFarmSelectionTitle}}">✕</span>
                  </div>
                  <div *ngFor="let itemmenu of getSelectedItemsInGroup(group)"
                       id="{{menu.Code + '_' + itemmenu.Id}}"
                       (click)="itemMenuClick($event)"
                       class="menu-item checked_{{itemmenu.Checked}}">
                    <div id="{{menu.Code + '_' + itemmenu.Id}}" class="checkbox checked_{{itemmenu.Checked}}"></div>
                    {{itemmenu.Value}}
                  </div>
                </div>
                <div class="separator" *ngIf="hasUnselectedResults(menu)">
                  
                </div>
              </div>
               <div   class="apply-mobile-filtered-list" *ngIf="IsMobile && changedMenus[menu.Code]">
                      <input type="button" value="Appliquer" (click)="onClickApplyFilterSelection($event, menu.Code)" title="Appliquer la sélection">
                </div>

              <!-- Liste des groupes et éléments filtrés -->
              <div *ngFor="let group of getFilteredGroups(menu)" class="unselected-items-section" [class.limit-selection-reached]="IsLimitSelectionReached(menu.Code, group)">
                <ng-container *ngIf="getFilteredItemsInGroup(group, menu.Code).length > 0">
                  <div *ngIf="group.Title != 'Default' && menu.GroupItems.length > 1 && shouldShowGroupTitle(group, menu.Code)"
                      class="group-title"
                      id="{{menu.Code + '_' + group.Id+'_MenuGroup'}}">
                    {{group.Title}}
                  </div>
                  <div *ngFor="let itemmenu of getFilteredItemsInGroup(group, menu.Code)"
                      id="{{menu.Code + '_' + itemmenu.Id}}"
                      (click)="itemMenuClick($event)"
                      class="menu-item checked_{{itemmenu.Checked}}">
                    <div id="{{menu.Code + '_' + itemmenu.Id}}" class="checkbox checked_{{itemmenu.Checked}}"></div>
                    <span [innerHTML]="highlightSearchTerm(itemmenu.Value, searchTerms[menu.Code])"></span>
                  </div>
                </ng-container>
              </div>

              <!-- Message si aucun résultat -->
              <div *ngIf="searchTerms[menu.Code] && getFilteredGroups(menu).length === 0 && Selected(menu.Code) === 0"
                   class="no-results">
                Aucun résultat trouvé
              </div>
            </div>
          </div>

            <!-- le menu campagne -->
          <div class="monoselectable" *ngIf="menu.Checkable == 2">
            <div class="menu-title">
              {{menu.Title}}
            </div>
            <div class="menu-items"  *ngIf="!menu.MonoRefresh">
                <div *ngFor="let group of menu.GroupItems" >
                  <div *ngFor="let itemmenu of group.Items" id="{{menu.Code + '_' + itemmenu.Id}}" (click)="itemMenuClick($event)" class="menu-item checked_{{itemmenu.Checked}}">
                    {{itemmenu.Value}}
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div class="validate-list">
          <input type="button" value="Valider" (click)="showPopupFilter = !showPopupFilter">
        </div>
      </div>
    </div>
    <div class="menu-settings" *ngIf="devicesAvailable">
      <div class="menu-settings-title">Paramètres</div>
      <div class="devices-btn-container">
        <div class="devices-btn" (click)="devicesClick.emit()" title="Consoles">
          <svg width="12" height="15" viewBox="0 0 12 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.275 0.287598C10.9273 0.287598 11.4562 0.816461 11.4562 1.46885V13.2814C11.4562 13.9337 10.9273 14.4626 10.275 14.4626H2.0062C1.35381 14.4626 0.824951 13.9337 0.824951 13.2814V1.46885C0.824951 0.816461 1.35381 0.287598 2.0062 0.287598H10.275ZM5.74683 12.1001C5.42063 12.1001 5.1562 12.3645 5.1562 12.6907C5.1562 13.0169 5.42063 13.2814 5.74683 13.2814H6.92808C7.25427 13.2814 7.5187 13.0169 7.5187 12.6907C7.5187 12.3645 7.25427 12.1001 6.92808 12.1001H5.74683ZM3.5812 1.8626C2.92881 1.8626 2.39995 2.39146 2.39995 3.04385V9.7376C2.39995 10.39 2.92881 10.9188 3.5812 10.9188H8.69995C9.35234 10.9188 9.8812 10.39 9.8812 9.7376V3.04385C9.8812 2.39146 9.35234 1.8626 8.69995 1.8626H3.5812Z"/>
          </svg>
          <span>Consoles</span>
        </div>
      </div>
    </div>
    <div class="menu-actions">
      <div *ngFor="let menu of ActionMenus()" class="jarvis-ui-menu">
        <div class="actionMenu" *ngIf="menu.Checkable == 3">
          <div class="menu-title">
            {{menu.Title}}
          </div>
          <div class="menu-items-action">
              <div *ngFor="let group of menu.GroupItems">
            <div *ngFor="let itemmenu of group.Items" id="{{menu.Code + '_' + itemmenu.Id}}" (click)="itemActionClick(menu.Code,itemmenu.Id)" class="menu-action checked_{{itemmenu.Checked}}" title="{{itemmenu.Title}}">
              <i id="{{menu.Code + '_' + itemmenu.Id}}" class="{{itemmenu.Image}}"></i>
              <span>{{itemmenu.Title}}</span>
            </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <i id="id_export_connected_states" *ngIf="IncludeConnectedStates" class="ic_export_connected_states_white ic_export_connected_states_button {{classExportConnectedState}}" title="{{IconConnectedStatesTitle}}" (click)="onIconConnectedStatsClick()"></i>
    </div>
  </div>
</div>

<app-jarvis-popup></app-jarvis-popup>
